import { CoverageIdEnum, PolicyProductIdEnum } from 'outshared-lib';

export const coverageVehicleData = {
    descriptions: {
        [PolicyProductIdEnum.Car]: [
            {label: 'Schade aan andere auto\'s'},
            {label: 'Ruitbreuk- en barsten'},
            {label: 'Diefstal, brand en storm'},
            {label: 'Schade aan eigen auto'},
            {label: 'Aanschaf-/ nieuwwaarde'},
        ],
        [PolicyProductIdEnum.Caravan]: [
            {label: 'Benelux en Duitsland'},
            {label: 'Heel Europa'},
        ],
        [PolicyProductIdEnum.Moped]: [
            {label: 'Schade aan anderen'},
            {label: 'Diefstal, brand en storm'},
            {label: 'Botsing met een dier'},
            {label: 'Accessoires incl. helm'},
            {label: 'Vergoeding voor vervangend vervoer'},
            {label: 'Zelf schade gemaakt aan eigen brommer'},
        ],
        [PolicyProductIdEnum.Motorcycle]: [
            {label: 'Schade aan anderen'},
            {label: 'Diefstal, brand en storm'},
            {label: 'Schade aan eigen motor'},
            {label: 'Schade tijdens parkeren'},
            {label: 'Aanschaf-/ nieuwwaarde'},
        ],
    },
    options: {
        [CoverageIdEnum.CarLegalLiability]: {
            id: CoverageIdEnum.CarLegalLiability,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
            ],
        } ,
        [CoverageIdEnum.CarLimitedCasco]: {
            id: CoverageIdEnum.CarLimitedCasco,
            options:  [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
                { type: 'string', value : 'tot 2 jaar' },
            ],
        },
        [CoverageIdEnum.CarLimitedCascoExtra]: {
            id: CoverageIdEnum.CarLimitedCascoExtra,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'string', value : '50%'  },
                { type: 'string', value : 'tot 2 jaar' },
            ],
        },
        [CoverageIdEnum.CarAllrisk]: {
            id: CoverageIdEnum.CarAllrisk,
            options:  [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'string', value : '100%'  },
                { type: 'string', value : 'tot 3 jaar' },
            ],
        },
        [CoverageIdEnum.CaravanAllriskBenelux]: {
            id: CoverageIdEnum.CaravanAllriskBenelux,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
            ],
        } ,
        [CoverageIdEnum.CaravanAllriskEurope]: {
            id: CoverageIdEnum.CaravanAllriskEurope,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
            ],
        },
        [CoverageIdEnum.MopedLegalLiability]: {
            id: CoverageIdEnum.MopedLegalLiability,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
            ],
        },
        [CoverageIdEnum.MopedLimitedCasco]: {
            id: CoverageIdEnum.MopedLimitedCasco,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
            ],
        },
        [CoverageIdEnum.MopedAllrisk]: {
            id: CoverageIdEnum.MopedAllrisk,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
            ],
        },
        [CoverageIdEnum.MotorLimitedCasco]: {
            id: CoverageIdEnum.MotorLimitedCasco,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
            ],
        },
        [CoverageIdEnum.MotorInStorage]: {
            id: CoverageIdEnum.MotorInStorage,
            options:  [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : true },
            ],
        },
        [CoverageIdEnum.MotorAllrisk]: {
            id: CoverageIdEnum.MotorAllrisk,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
            ],
        },
    },
};
